import { render, staticRenderFns } from "./ServerView.vue?vue&type=template&id=ba6fd40c&"
import script from "./ServerView.vue?vue&type=script&lang=js&"
export * from "./ServerView.vue?vue&type=script&lang=js&"
import style0 from "./ServerView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports